<template>
    <transition name="el-fade-in-linear" style="position: relative">
        <div v-show="showMain" class="transition-box">
            <div id="formblock">
                <el-form label-position="top" label-width="80px" :model="searchForm">
                    <el-row :gutter="30">
                        <el-col :span="3">
                            <el-form-item label="餐飲平台">
                                <el-select v-model="searchForm.CUST_CODE" style="width:100%;" @change="getBrandOptions(searchForm.CUST_CODE); searchForm.BRAND_NAME='';">
                                    <el-option key="ALL" label="ALL" value=""></el-option>
                                    <el-option v-for="item in custOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="3">
                            <el-form-item label="品牌">
                                <el-select v-model="searchForm.BRAND_NAME" clearable filterable allow-create style="width:100%;">
                                    <el-option key="ALL" label="ALL" value=""></el-option>
                                    <el-option v-for="item in brandOptions" :key="item.value" :label="item.label" :value="item.label"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="3">
                            <el-form-item label="出貨門店名稱/代號">
                                <el-input v-model="searchForm.DEPT_COMP" style="width: 100%;"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="3">
                            <el-form-item label="付款對象代號">
                                <el-input v-model="searchForm.PAY_VENDOR" style="width:100%;"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="3">
                            <el-form-item label="託運單號">
                                <el-input v-model="searchForm.DLV_NO" style="width:100%;"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="3">
                            <el-form-item label="物流狀態">
                                <el-input v-model="searchForm.LAST_STATUS_CODE" style="width:100%;"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="日期範圍">
                                <el-date-picker v-model="searchForm.DATE" type="daterange" range-separator="~" start-placeholder="" end-placeholder="" format="YYYY/MM/DD" value-format="YYYY/MM/DD" />
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
                <el-row type="flex" justify="center">
                    <el-col :span="6" style="margin-top: auto; margin-bottom: auto;">
                        <el-button style="width: 100%" type="primary" @click="onSearch" v-show="store.getters.check_auth('SEARCH')">Search</el-button>
                    </el-col>
                </el-row>
            </div>
            <div id="datablock" style="height: calc(100vh - 352px)">
                <el-row type="flex" justify="end">
                    <el-button type="primary" round plain @click="onBillClick('table', 'Confirm')">帳單確認</el-button>
                    <el-button type="primary" round plain @click="onExportClick" v-show="store.getters.check_auth('PRINT')">下載明細</el-button>
                </el-row>

                <div ref="table" style="margin-top:10px;"></div>

                <!-- Edit -->
                <el-dialog v-model="dialogFormVisible" :title="dialogTitle" @opened="onDialogOpen" top="1vh" width="950px" :close-on-click-modal="false" style="height: 93vh">
                    <el-form :model="form" label-width="auto" label-position="top">
                        <el-row :gutter="30">
                            <el-col :span="12">
                                <el-row>
                                    <el-col>帳單序號: {{form.BILL_SEQ.toString().padStart(7, "0")}}</el-col>
                                    <el-col>託運序號: {{form.DLV_SEQ.toString().padStart(7, "0")}}</el-col>
                                </el-row>
                            </el-col>
                            <el-col :span="12">
                                <el-row :gutter="10">
                                    <el-col :span="12" v-show="form.BILL_STATUS!=''">
                                        <el-tag type="danger" size="large" effect="plain" v-if="form.BILL_STATUS == 'N'">VOID</el-tag>
                                        <el-tag type="primary" size="large" effect="plain" v-else>Confirmed</el-tag>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-tag type="danger" size="large" effect="plain" v-show="form.AMEND_FG=='Y'">AMEND</el-tag>
                                    </el-col>
                                </el-row>
                            </el-col>
                        </el-row>
                        <el-scrollbar height="calc(93vh - 235px)">
                            <el-row :gutter="30">
                                <el-col :span="12">
                                    <el-form-item label="託運單號" :prop="DLV_NO">
                                        <el-input v-model="form.DLV_NO" disabled></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="客戶訂單號" :prop="WORK_NO">
                                        <el-input v-model="form.WORK_NO" disabled></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row :gutter="30">
                                <el-col :span="12">
                                    <el-form-item label="餐飲平台" :prop="CUST">
                                        <el-input v-model="form.CUST" disabled></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="原始訂單號" :prop="SHIP_REF">
                                        <el-input v-model="form.SHIP_REF" disabled></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row :gutter="30">
                                <el-col :span="12">
                                    <el-form-item label="出貨品牌" :prop="BRAND_NAME">
                                        <el-input v-model="form.BRAND_NAME" disabled></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="6">
                                    <el-form-item label="門店編號" :prop="DEPT_COMP_ID">
                                        <el-input v-model="form.DEPT_COMP_ID" disabled></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="6">
                                    <el-form-item label="付款方編號" :prop="PAY_VENDOR">
                                        <el-input v-model="form.PAY_VENDOR" disabled></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row :gutter="30">
                                <el-col :span="12">
                                    <el-form-item label="出貨門店" :prop="DEPT_COMP_NAME">
                                        <el-input v-model="form.DEPT_COMP_NAME" disabled></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="出貨地址" :prop="DEPT_ADDR">
                                        <el-input v-model="form.DEPT_ADDR" disabled></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row :gutter="30">
                                <el-col :span="12">
                                    <el-form-item label="收件人" :prop="DEST_COMP_NAME">
                                        <el-input v-model="form.DEST_COMP_NAME" disabled></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="收件地址" :prop="DEST_ADDR">
                                        <el-input v-model="form.DEST_ADDR" disabled></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row :gutter="30">
                                <el-col :span="12">
                                    <el-row :gutter="20">
                                        <el-col :span="12">
                                            <el-form-item label="出貨日期" :prop="DEPT_TIME">
                                                <el-date-picker v-model="form.DEPT_TIME" type="date" format="YYYY/MM/DD" value-format="YYYY/MM/DD" disabled />
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label="取貨時段" :prop="DEPT_PERIOD">
                                                <el-date-picker v-model="form.DEPT_PERIOD" type="datetime" format="HH:mm" value-format="HH:mm" disabled />
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </el-col>
                                <el-col :span="12">
                                    <el-row :gutter="20">
                                        <el-col :span="12">
                                            <el-form-item label="商品數量" :prop="QTY">
                                                <el-input-number v-model="form.QTY" :controls="false" disabled></el-input-number>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label="商品總價" :prop="PRODUCT_AMT">
                                                <el-input-number v-model="form.PRODUCT_AMT" :controls="false" disabled></el-input-number>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </el-col>
                            </el-row>
                            <el-row :gutter="30">
                                <el-col>
                                    <el-form-item label="貨品說明" :prop="GOODS_DESC">
                                        <el-input type="textarea" v-model="form.GOODS_DESC" :rows="2" disabled></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row :gutter="30">
                                <el-col :span="12">
                                    <el-row :gutter="20">
                                        <el-col :span="6">
                                            <el-form-item label="物流收款" :prop="CHARGE_AMT">
                                                <el-input-number v-model="form.CHARGE_AMT" :controls="false" :disabled="form.BILL_STATUS !=''"></el-input-number>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="6">
                                            <el-form-item label="物流付款" :prop="PAYMENT_AMT">
                                                <el-input-number v-model="form.PAYMENT_AMT" :controls="false" :disabled="form.BILL_STATUS !=''"></el-input-number>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="6">
                                            <el-form-item label="加派費" :prop="ADD_DLV_AMT">
                                                <el-input-number v-model="form.ADD_DLV_AMT" :controls="false" :disabled="form.BILL_STATUS !=''"></el-input-number>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="6">
                                            <el-form-item label="返送費" :prop="RETURN_AMT">
                                                <el-input-number v-model="form.RETURN_AMT" :controls="false" :disabled="form.BILL_STATUS !=''"></el-input-number>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </el-col>
                                <el-col :span="12">
                                    <el-row :gutter="20">
                                        <el-col :span="12">
                                            <el-form-item label="代收貨款" :prop="COLLECT_AMT">
                                                <el-input-number v-model="form.COLLECT_AMT" :controls="false" :disabled="form.BILL_STATUS !=''"></el-input-number>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label="手續費" :prop="HANDLE_AMT">
                                                <el-input-number v-model="form.HANDLE_AMT" :controls="false" :disabled="form.BILL_STATUS !=''"></el-input-number>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </el-col>
                            </el-row>
                            <el-row :gutter="30">
                                <el-col :span="12">
                                    <el-row :gutter="20">
                                        <el-col>
                                            <el-form-item label="運輸公司" :prop="TRANS">
                                                <el-input v-model="form.TRANS" disabled></el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                    <el-row :gutter="20">
                                        <el-col :span="12">
                                            <el-form-item label="預估距離" :prop="EST_DLV_KM">
                                                <el-input-number v-model="form.EST_DLV_KM" :controls="false" precision="3" disabled></el-input-number>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label="計價距離" :prop="CHARGE_DLV_KM">
                                                <el-input-number v-model="form.CHARGE_DLV_KM" :controls="false" precision="3" disabled></el-input-number>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="費用備註" :prop="REMARKS">
                                        <el-input type="textarea" v-model="form.REMARKS" :rows="4" :disabled="form.BILL_STATUS !=''"></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row :gutter="30">
                                <el-col :span="12">
                                    <el-row :gutter="20">
                                        <el-col :span="12">
                                            <el-form-item label="訂單指定外送" :prop="EST_TRANS">
                                                <el-input v-model="form.EST_TRANS" disabled></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label="實際外送" :prop="ACT_TRANS">
                                                <el-input v-model="form.ACT_TRANS" disabled></el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="外送平台單號" :prop="TRANS_ORDER_ID">
                                        <el-input v-model="form.TRANS_ORDER_ID" disabled></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row :gutter="30">
                                <el-col :span="12">
                                    <el-form-item label="最後狀態" :prop="LAST_STATUS">
                                        <el-input v-model="form.LAST_STATUS" disabled></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="時間" :prop="LAST_STATUS_TIME">
                                        <el-input v-model="form.LAST_STATUS_TIME" disabled></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-scrollbar>
                    </el-form>
                    <template #footer>
                        <el-form :model="form" label-width="fit-content" label-position="right">
                            <el-row :gutter="30">
                                <el-col :span="12">
                                    <el-form-item :prop="EDIT_USER">
                                        <template #label>
                                            <el-text style="line-height: 20px">修改人</el-text>
                                        </template>
                                        <template #default>
                                            <el-text style="line-height: 20px;text-align: left">{{form.EDIT_USER}}<br />{{form.EDIT_TIME}}</el-text>
                                        </template>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item :prop="VOID_USER" v-if="form.BILL_STATUS=='N'">
                                        <template #label>
                                            <el-text style="line-height: 20px">作廢人員</el-text>
                                        </template>
                                        <template #default>
                                            <el-text style="line-height: 20px;text-align: left">{{form.VOID_USER}}<br />{{form.VOID_TIME}}</el-text>
                                        </template>
                                    </el-form-item>
                                    <el-form-item :prop="CONFIRM_USER" v-else>
                                        <template #label>
                                            <el-text style="line-height: 20px">帳單確認</el-text>
                                        </template>
                                        <template #default>
                                            <el-text style="line-height: 20px;text-align: left">{{form.CONFIRM_USER}}<br />{{form.CONFIRM_TIME}}</el-text>
                                        </template>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row :gutter="30" justify="center">
                                <el-col :span="5">
                                    <el-dropdown trigger="contextmenu" style="width: 100%;">
                                        <span class="el-dropdown-link" style="width: 100%;">
                                            <el-button type="info" @click="onBillClick('form', 'Confirm')" style="width: 100%;">帳單確認</el-button>
                                        </span>
                                        <template #dropdown>
                                            <el-dropdown-menu v-show="form.BILL_STATUS=='Y'">
                                                <el-dropdown-item @click="onBillClick('form', 'ConfirmCancel')">取消確認</el-dropdown-item>
                                            </el-dropdown-menu>
                                        </template>
                                    </el-dropdown>
                                </el-col>
                                <el-col :span="5">
                                    <el-dropdown trigger="contextmenu" style="width: 100%;">
                                        <span class="el-dropdown-link" style="width: 100%;">
                                            <el-button type="info" @click="onBillClick('form', 'Void')" style="width: 100%;">帳單作廢</el-button>
                                        </span>
                                        <template #dropdown>
                                            <el-dropdown-menu v-show="form.BILL_STATUS=='N'">
                                                <el-dropdown-item @click="onBillClick('form', 'VoidCancel')">取消作廢</el-dropdown-item>
                                            </el-dropdown-menu>
                                        </template>
                                    </el-dropdown>
                                </el-col>
                                <el-col :span="5">
                                    <el-button type="primary" @click="onBeforeSave" style="width: 100%;">存檔</el-button>
                                </el-col>
                                <el-col :span="5">
                                    <el-button type="info" @click="dialogFormVisible = false" style="width: 100%;">取消</el-button>
                                </el-col>
                            </el-row>
                        </el-form>
                    </template>
                </el-dialog>
            </div>
        </div>
    </transition>
</template>

<script setup>
    import { ref, reactive, onBeforeMount, onMounted, nextTick } from 'vue';
    import { TabulatorFull as Tabulator } from 'tabulator-tables'; //import Tabulator library
    import { ElMessage, ElMessageBox, ElLoading } from 'element-plus'
    import { useDownload } from '@/composables/download'
    import $api from '@/utils/axios';
    import { useStore } from "vuex";
    const store = useStore();

    const showMain = ref(true);//顯示主頁面
    const dialogTitle = ref('');//dialog標題
    const dialogFormVisible = ref(false);//顯示dialog
    const IDdisabled = ref(false);//編輯時ID狀態
    const addOrEdit = ref('');
    const formData = ref(null);

    const table = ref(null); //reference to your table element
    const tabulator = ref(null); //variable to hold your table

    //下拉選單

    const searchForm = reactive({
        CUST_CODE: '',    // 餐飲平台
        BRAND_NAME: '',   // 品牌
        VENDOR: '',       // 門店名稱/代號
        DLV_NO:'',        // 託運單號
        LAST_STATUS_CODE: '', // 物流狀態
        DATE: [],
        type: 'OrderFee',
    });

    const form = ref({
        BILL_SEQ: '',
        DLV_SEQ: '',
        BILL_STATUS: '',
        AMEND_FG: '',
        DLV_NO: '',
        WORK_NO: '',
        CUST: '',
        CUST_CODE: '',
        CUST_NAME: '',
        SHIP_REF: '',
        BRAND_NAME: '',
        DEPT_COMP_ID: '',
        PAY_VENDOR: '',
        DEPT_COMP_NAME: '',
        DEPT_ADDR: '',
        DEST_COMP_NAME: '',
        DEST_ADDR: '',
        DEPT_TIME: '',
        DEPT_PERIOD: '',
        QTY: '',
        PRODUCT_AMT: '',
        GOODS_DESC: '',
        CHARGE_AMT: '',
        PAYMENT_AMT: '',
        COLLECT_AMT: '',
        HANDLE_AMT: '',
        TRANS: '',
        TRANS_COMP: '',
        TRANS_NAME: '',
        EST_DLV_KM: '',
        CHARGE_DLV_KM: '',
        REMARKS: '',
        EST_TRANS: '',
        ACT_TRANS: '',
        TRANS_ORDER_ID: '',
        LAST_STATUS: '',
        LAST_STATUS_CODE: '',
        LAST_STATUS_DESC: '',
        LAST_STATUS_TIME: '',
        ORG_FIELD: '',
    });

    // 搜尋
    const onSearch = () => {
        // 日期範圍
        if (searchForm.DATE == null || searchForm.DATE.length == 0) {
            searchForm.START_DATE = "";
            searchForm.END_DATE = "";
        } else {
            searchForm.START_DATE = searchForm.DATE[0];
            searchForm.END_DATE = searchForm.DATE[1];
        }
        onLoadTable("search");
    }

    const onLoadTable = (type) => {
        $api.GET('/api/DtBill/GetTableData', searchForm).then((response) => {
            if (type == "update") {
                // 畫面只更新該筆資料，避免存檔後跳回到第一頁
                tabulator.value.updateData(response);
            } else {
                tabulator.value.setData(response);
            }
        });
    }

    // Confirm, Void
    const onBillClick = (tag, type) => {
        let selectedData = [];
        let msg = "";
        if (tag == "table") {
            selectedData = tabulator.value.getSelectedData();
            msg = "是否對已經勾選的帳單進行確認?";
        } else { //form
            selectedData.push(form.value);
            switch (type) {
                case "Confirm":
                    msg = "是否確認本筆訂單費用?";
                    break;
                case "ConfirmCancel":
                    msg = "是否取消本筆訂單費用的確認狀態?";
                    break;
                case "Void":
                    msg = "是否本筆訂單費用進行作廢?";
                    break;
                case "VoidCancel":
                    msg = "是否取消本筆訂單費用的作廢狀態?";
                    break;
            }
        }

        if (selectedData.length == 0) {
            ElMessageBox.alert('請勾選項目!', '提示', {
                confirmButtonText: '確定'
            });
        } else {
            ElMessageBox.confirm(msg, '提示', {
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
            }).then(() => { //yes
                onUpdateSubmit(selectedData, type);
            }).catch(() => { }); //no;
        }
    }

    const onUpdateSubmit = (selectedData, type) => {
        $api.POST('/api/DtBill/Update', {
            param: selectedData, type: type
        }).then((res) => {
            if (res >= 1) {
                ElMessageBox.alert('更新成功!', '提示', {
                    confirmButtonText: '確定',
                    callback: action => {
                        onLoadTable("update");
                        tabulator.value.deselectRow(); //取消勾選
                        dialogFormVisible.value = false;
                    }
                });
            } else {
                ElMessageBox.alert('更新失敗!', '提示', {
                    confirmButtonText: '確定'
                });
            }
        });
    }

    // 匯出Excel
    const onExportClick = () => {
        $api.POST('/api/DtBill/ExportExcel',
            searchForm
        ).then((response) => {
            useDownload('/api/Home/DownloadFile?URL_ADDR=' + response, response.split('\\')[1]);
        });
    }

    // 編輯
    const onEditClick = (e, cell) => {
        formData.value = JSON.parse(JSON.stringify(cell.getData()));
        form.value = JSON.parse(JSON.stringify(cell.getData()));
        dialogTitle.value = "[訂單費用編輯]";
        addOrEdit.value = 'edit';
        dialogFormVisible.value = true;
    }

    const onDialogOpen = () => {
        nextTick(() => {
            if (addOrEdit.value == 'edit') {
                form.value.CUST = form.value.CUST_CODE + " / " + form.value.CUST_NAME;
                form.value.TRANS = form.value.TRANS_COMP + " / " + form.value.TRANS_NAME;
                form.value.LAST_STATUS = form.value.LAST_STATUS_CODE + " / " + form.value.LAST_STATUS_DESC;
                //console.log(form.value);
            }
        });
    }

    const onBeforeSave = () => {
        //有欄位資料異動時,才進行寫入資料及存檔
        formData.value.REMARKS = formData.value.REMARKS == "" ? null : formData.value.REMARKS;
        form.value.REMARKS = form.value.REMARKS == "" ? null : form.value.REMARKS;

        // formData原本的值, form修改後的值
        if (formData.value.CHARGE_AMT != form.value.CHARGE_AMT || formData.value.PAYMENT_AMT != form.value.PAYMENT_AMT ||
            formData.value.COLLECT_AMT != form.value.COLLECT_AMT || formData.value.HANDLE_AMT != form.value.HANDLE_AMT ||
            formData.value.ADD_DLV_AMT != form.value.ADD_DLV_AMT || formData.value.RETURN_AMT != form.value.RETURN_AMT || 
            formData.value.REMARKS != form.value.REMARKS) {
            form.value.ORG_FIELD = "";
            if (formData.value.CHARGE_AMT != form.value.CHARGE_AMT) form.value.ORG_FIELD += "CHARGE_AMT:" + formData.value.CHARGE_AMT + "->" + form.value.CHARGE_AMT + "\n";
            if (formData.value.PAYMENT_AMT != form.value.PAYMENT_AMT) form.value.ORG_FIELD += "PAYMENT_AMT:" + formData.value.PAYMENT_AMT + "->" + form.value.PAYMENT_AMT + "\n";
            if (formData.value.COLLECT_AMT != form.value.COLLECT_AMT) form.value.ORG_FIELD += "COLLECT_AMT:" + formData.value.COLLECT_AMT + "->" + form.value.COLLECT_AMT + "\n";
            if (formData.value.HANDLE_AMT != form.value.HANDLE_AMT) form.value.ORG_FIELD += "HANDLE_AMT:" + formData.value.HANDLE_AMT + "->" + form.value.HANDLE_AMT + "\n";
            if (formData.value.ADD_DLV_AMT != form.value.ADD_DLV_AMT) form.value.ORG_FIELD += "ADD_DLV_AMT:" + formData.value.ADD_DLV_AMT + "->" + form.value.ADD_DLV_AMT + "\n";
            if (formData.value.RETURN_AMT != form.value.RETURN_AMT) form.value.ORG_FIELD += "RETURN_AMT:" + formData.value.RETURN_AMT + "->" + form.value.RETURN_AMT + "\n";
            if (formData.value.REMARKS != form.value.REMARKS) form.value.ORG_FIELD += "REMARKS(原):" + formData.value.REMARKS + "\nREMARKS(改):" + form.value.REMARKS;
            onSave();
        } else {
            ElMessageBox.confirm('未更動資料, 是否要關閉本畫面?', '提示', {
                confirmButtonText: '是',
                cancelButtonText: '否',
            }).then(() => { //是
                onLoadTable("update");
                dialogFormVisible.value = false;
            }).catch(() => { }); //否
        }
    }

    // 存檔
    const onSave = () => {
        $api.POST('/api/DtBill/Edit',
            form.value
        ).then((res) => {
            if (res >= 1) {
                ElMessageBox.alert('更新成功!', '提示', {
                    confirmButtonText: '確定',
                    callback: action => {
                        onLoadTable("update");
                        dialogFormVisible.value = false;
                    }
                });
            } else {
                ElMessageBox.alert('更新失敗!', '提示', {
                    confirmButtonText: '確定'
                });
            }
        });
    }

    // 取得下拉
    const getOptions = () => {
        getCustCodeOptions();
    }

    const custOptions = ref([]);
    const getCustCodeOptions = () => { // 取得[餐飲平台]下拉
        $api.GET('/api/Outlet/GetCustCodeOptions', {
        }).then((response) => {
            custOptions.value = response;
        });
    }

    const brandOptions = ref([]);
    const getBrandOptions = (CUST_CODE) => { // 取得[品牌]下拉
        $api.GET('/api/Outlet/GetBrandNameOptions', {
            CUST_CODE: CUST_CODE
        }).then((response) => {
            brandOptions.value = response;
        });
    }

    const editIcon = (cell, formatterParams) => {
        return '<i class="el-icon"><svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"><path d="m199.04 672.64 193.984 112 224-387.968-193.92-112-224 388.032zm-23.872 60.16 32.896 148.288 144.896-45.696L175.168 732.8zM455.04 229.248l193.92 112 56.704-98.112-193.984-112-56.64 98.112zM104.32 708.8l384-665.024 304.768 175.936L409.152 884.8h.064l-248.448 78.336L104.32 708.8zm384 254.272v-64h448v64h-448z" fill="currentColor"></path></svg></i>';
    }

    onMounted(() => {
        getOptions();
        // search日期預設帶入當天日期
        let today = new Date().toISOString().split('T')[0];
        searchForm.DATE = [today, today];

        //instantiate Tabulator when element is mounted
        tabulator.value = new Tabulator(table.value, {
            locale: "zh-tw",
            layout: "fitColumns",      //fit columns to width of table
            maxHeight: "calc(100vh - 392px)", //do not let table get bigger than the height of its parent element
            rowHeight: 50,
            columnHeaderVertAlign: "middle", //align header contents to middle of cell
            //selectable: true,
            headerVisible: true,
            pagination: true,       //paginate the data
            paginationSize: 50,         //allow 50 rows per page of data
            paginationSizeSelector: [50, 100, 200],
            index: "BILL_SEQ",
            columns: [
                { title: "序號", formatter: "rownum", width: 40, headerHozAlign: "center", hozAlign: "center", vertAlign: "middle", headerSort: false },
                { titleFormatter: "rowSelection", field: "", formatter: "rowSelection", width: 40, headerHozAlign: "center", hozAlign: "center", vertAlign: "middle", headerSort: false },
                {
                    title: "帳單<br />狀態", field: "BILL_STATUS", width: 50, headerHozAlign: "center", hozAlign: "center", vertAlign: "middle", headerSort: false,
                    formatter: function (cell, formatterParams, onRendered) {
                        if (cell.getValue() == 'N') {
                            return "<p style='color: red'>N</p>"
                        } else if (cell.getValue() == 'Y') {
                            return "<p style='color: blue'>Y</p>";
                        } else {
                            return "";
                        }
                    }
                },
                { title: "Amd", field: "AMEND_FG", width: 50, headerHozAlign: "center", hozAlign: "center", vertAlign: "middle", headerSort: false },
                { title: "餐飲平台", field: "CUST_NAME", width: 100, headerHozAlign: "center", hozAlign: "center", vertAlign: "middle", headerSort: true },
                {
                    title: "品牌<br />門店名稱", field: "BRAND_NAME", width: 100, headerHozAlign: "center", hozAlign: "left", vertAlign: "middle", headerSort: true,
                    formatter: function (cell, formatterParams, onRendered) {
                        return cell.getValue() + "<br />" + cell.getData().DEPT_COMP_NAME;
                    }
                },
                { title: "付款對象", field: "PAY_VENDOR", width: 100, headerHozAlign: "center", hozAlign: "center", vertAlign: "middle", headerSort: true },
                { title: "訂單日期", field: "DEPT_TIME", width: 100, headerHozAlign: "center", hozAlign: "center", vertAlign: "middle", headerSort: true },
                { title: "託運單號", field: "DLV_NO", width: 150, headerHozAlign: "center", hozAlign: "center", vertAlign: "middle", headerSort: true },
                { title: "商家訂單號", field: "WORK_NO", width: 200, headerHozAlign: "center", hozAlign: "left", vertAlign: "middle", headerSort: true },
                { title: "客戶名稱", field: "DEST_COMP_NAME", width: 100, headerHozAlign: "center", hozAlign: "left", vertAlign: "middle", headerSort: false },
                { title: "外送平台", field: "ACT_TRANS", width: 90, headerHozAlign: "center", hozAlign: "center", vertAlign: "middle", headerSort: true },
                {
                    title: "物流狀態", field: "LAST_STATUS_CODE", width: 70, headerHozAlign: "center", hozAlign: "center", vertAlign: "middle", headerSort: false,
                    formatter: function (cell, formatterParams, onRendered) {
                        if (cell.getValue() == "ST04") {
                            return "已送達";
                        } else if (cell.getValue() == "ST05") {
                            return "已取消";
                        } else {
                            return cell.getValue();
                        }
                    }
                },
                {
                    title: "預估距離<br />(KM)", field: "EST_DLV_KM", width: 75, headerHozAlign: "center", hozAlign: "center", vertAlign: "middle", headerSort: false,
                    formatter: function (cell, formatterParams, onRendered) {
                        // Format #,##0.000
                        let val = cell.getValue();
                        if (val == 0 || val == null) {
                            return "";
                        } else {
                            return val.toFixed(3).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                        }
                    }
                },
                {
                    title: "計價距離<br />(KM)", field: "CHARGE_DLV_KM", width: 75, headerHozAlign: "center", hozAlign: "center", vertAlign: "middle", headerSort: false,
                    formatter: function (cell, formatterParams, onRendered) {
                        // Format #,##0.000
                        let val = cell.getValue();
                        if (val == 0 || val == null) {
                            return "";
                        } else {
                            return val.toFixed(3).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                        }
                    }
                },
                {
                    title: "物流收款", field: "CHARGE_AMT", width: 65, headerHozAlign: "center", hozAlign: "center", vertAlign: "middle", headerSort: false,
                    formatter: function (cell, formatterParams, onRendered) {
                        // Format #,##0
                        let val = cell.getValue();
                        if (val == 0 || val == null) {
                            return "";
                        } else {
                            return val.toFixed().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                        }
                    }
                },
                {
                    title: "物流付款", field: "PAYMENT_AMT", width: 65, headerHozAlign: "center", hozAlign: "center", vertAlign: "middle", headerSort: false,
                    formatter: function (cell, formatterParams, onRendered) {
                        // Format #,##0
                        let val = cell.getValue();
                        if (val == 0 || val == null) {
                            return "";
                        } else {
                            return val.toFixed().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                        }
                    }
                },
                {
                    title: "代收款", field: "COLLECT_AMT", width: 65, headerHozAlign: "center", hozAlign: "center", vertAlign: "middle", headerSort: false,
                    formatter: function (cell, formatterParams, onRendered) {
                        // Format #,##0
                        let val = cell.getValue();
                        if (val == 0 || val == null) {
                            return "";
                        } else {
                            return val.toFixed().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                        }
                    }
                },
                {
                    title: "手續費", field: "HANDLE_AMT", width: 65, headerHozAlign: "center", hozAlign: "center", vertAlign: "middle", headerSort: false,
                    formatter: function (cell, formatterParams, onRendered) {
                        // Format #,##0
                        let val = cell.getValue();
                        if (val == 0 || val == null) {
                            return "";
                        } else {
                            return val.toFixed().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                        }
                    }
                },
                {
                    title: "商品金額", field: "PRODUCT_AMT", width: 65, headerHozAlign: "center", hozAlign: "center", vertAlign: "middle", headerSort: false,
                    formatter: function (cell, formatterParams, onRendered) {
                        // Format #,##0
                        let val = cell.getValue();
                        if (val == 0 || val == null) {
                            return "";
                        } else {
                            return val.toFixed().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                        }
                    }
                },
                {
                    title: "加派費", field: "ADD_DLV_AMT", width: 65, headerHozAlign: "center", hozAlign: "center", vertAlign: "middle", headerSort: false,
                    formatter: function (cell, formatterParams, onRendered) {
                        // Format #,##0
                        let val = cell.getValue();
                        if (val == 0 || val == null) {
                            return "";
                        } else {
                            return val.toFixed().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                        }
                    }
                },
                {
                    title: "返送費", field: "RETURN_AMT", width: 65, headerHozAlign: "center", hozAlign: "center", vertAlign: "middle", headerSort: false,
                    formatter: function (cell, formatterParams, onRendered) {
                        // Format #,##0
                        let val = cell.getValue();
                        if (val == 0 || val == null) {
                            return "";
                        } else {
                            return val.toFixed().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                        }
                    }
                },
                { title: "編輯", field: "edit", formatter: editIcon, width: 40, headerHozAlign: "center", hozAlign: "center", vertAlign: "middle", headerSort: false, cellClick: onEditClick }
            ],
            langs: {
                "zh-tw": {
                    "pagination": {
                        "page_size": "選擇筆數",
                        "first": "第一頁",
                        "last": "最後一頁",
                        "prev": "上一頁",
                        "next": "下一頁",
                    }
                }
            },
        });
        tabulator.value.on("tableBuilt", function () {
            if (!store.getters.check_auth('DEL')) {
                tabulator.value.hideColumn('delete');
            }
        });
    });

</script>

<style>
    .el-dialog__body {
        padding: 15px 20px;
    }

    .el-input-number {
        width: 100%;
    }

    .el-tag {
        width: 100%;
        font-size: 20px;
    }
</style>
